import React from "react";

export default function AiConsultation() {
  return (
    <div>
      <svg
        id="Group_106"
        data-name="Group 106"
        xmlns="http://www.w3.org/2000/svg"
        width="359.273"
        height="336.37"
        viewBox="0 0 359.273 336.37"
      >
        <defs>
          <clipPath id="clip-path">
            <rect
              id="Rectangle_132"
              data-name="Rectangle 132"
              width="359.273"
              height="336.37"
              fill="none"
            />
          </clipPath>
          <clipPath id="clip-path-3">
            <rect
              id="Rectangle_53"
              data-name="Rectangle 53"
              width="42.945"
              height="55.076"
              transform="translate(128.983 135.477)"
              fill="none"
            />
          </clipPath>
          <clipPath id="clip-path-4">
            <rect
              id="Rectangle_54"
              data-name="Rectangle 54"
              width="33.61"
              height="43.449"
              transform="translate(170.458 147.104)"
              fill="none"
            />
          </clipPath>
          <clipPath id="clip-path-5">
            <rect
              id="Rectangle_55"
              data-name="Rectangle 55"
              width="41.037"
              height="50.234"
              transform="translate(156.801 140.272)"
              fill="none"
            />
          </clipPath>
          <clipPath id="clip-path-6">
            <rect
              id="Rectangle_56"
              data-name="Rectangle 56"
              width="39.231"
              height="45.216"
              transform="translate(130.792 135.477)"
              fill="none"
            />
          </clipPath>
          <clipPath id="clip-path-8">
            <rect
              id="Rectangle_96"
              data-name="Rectangle 96"
              width="36"
              height="53.625"
              transform="translate(1.833 178.065)"
              fill="none"
            />
          </clipPath>
          <clipPath id="clip-path-9">
            <rect
              id="Rectangle_116"
              data-name="Rectangle 116"
              width="40.34"
              height="51.736"
              transform="translate(315.61 169.366)"
              fill="none"
            />
          </clipPath>
          <clipPath id="clip-path-10">
            <rect
              id="Rectangle_117"
              data-name="Rectangle 117"
              width="43.775"
              height="51.736"
              transform="translate(280.134 169.366)"
              fill="none"
            />
          </clipPath>
          <clipPath id="clip-path-11">
            <rect
              id="Rectangle_118"
              data-name="Rectangle 118"
              width="42.368"
              height="51.736"
              transform="translate(265.817 169.366)"
              fill="none"
            />
          </clipPath>
        </defs>
        <g id="Group_105" data-name="Group 105" clip-path="url(#clip-path)">
          <g id="Group_90" data-name="Group 90">
            <g id="Group_89" data-name="Group 89" clip-path="url(#clip-path)">
              <path
                id="Path_174"
                data-name="Path 174"
                d="M280.755,144.178a2.449,2.449,0,1,1,2.45,2.449A2.449,2.449,0,0,1,280.755,144.178Z"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_12"
                data-name="Line 12"
                y2="16.594"
                transform="translate(283.205 125.134)"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_175"
                data-name="Path 175"
                d="M253.862,86.447v13.608l9.849,5.035v12.928"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_176"
                data-name="Path 176"
                d="M293.621,148.127l-.125-7.936-5.811-5.251V122.012"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_177"
                data-name="Path 177"
                d="M274.249,157.956v-15.82l3.582-2.308V127.787"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_13"
                data-name="Line 13"
                y2="4.117"
                transform="translate(263.711 86.447)"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_14"
                data-name="Line 14"
                y2="6.705"
                transform="translate(263.711 94.473)"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_15"
                data-name="Line 15"
                y1="10.315"
                transform="translate(283.205 151.229)"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_16"
                data-name="Line 16"
                y1="16.594"
                transform="translate(67.764 103.795)"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_178"
                data-name="Path 178"
                d="M76.72,84.567v15.82L73.138,102.7v21.462"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_17"
                data-name="Line 17"
                y1="4.117"
                transform="translate(82.334 107.122)"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_179"
                data-name="Path 179"
                d="M203.665,61.994q-5.146.915-10.441,1.563a64.061,64.061,0,0,1-4.955,13.378,41.359,41.359,0,0,0,15.4-14.941"
                fill="#fff"
              />
              <path
                id="Path_180"
                data-name="Path 180"
                d="M209.4,42.705H195.9a93.264,93.264,0,0,1-1.879,17.361q5.91-.752,11.633-1.849A40.775,40.775,0,0,0,209.4,42.705"
                fill="#fff"
              />
              <path
                id="Path_181"
                data-name="Path 181"
                d="M170.05,82.052a40.786,40.786,0,0,0,12.912-2.645,54.312,54.312,0,0,0,6.686-15.46c-6.409.656-12.955,1.011-19.6,1.063Z"
                fill="#fff"
              />
              <path
                id="Path_182"
                data-name="Path 182"
                d="M205.655,23.836q-5.714-1.1-11.633-1.85a93.179,93.179,0,0,1,1.88,17.362h13.5a40.756,40.756,0,0,0-3.742-15.512"
                fill="#fff"
              />
              <path
                id="Path_183"
                data-name="Path 183"
                d="M170.05,61.652a204.53,204.53,0,0,0,20.464-1.174,89.329,89.329,0,0,0,2.031-17.773H170.05Z"
                fill="#fff"
              />
              <path
                id="Path_184"
                data-name="Path 184"
                d="M203.665,20.058a41.362,41.362,0,0,0-15.4-14.942A64.092,64.092,0,0,1,193.224,18.5q5.295.639,10.441,1.563"
                fill="#fff"
              />
              <path
                id="Path_185"
                data-name="Path 185"
                d="M170.05,39.348h22.495a89.413,89.413,0,0,0-2.031-17.774A204.217,204.217,0,0,0,170.05,20.4Z"
                fill="#fff"
              />
              <path
                id="Path_186"
                data-name="Path 186"
                d="M170.05,0V17.043c6.643.051,13.19.406,19.6,1.062a54.343,54.343,0,0,0-6.684-15.459A40.778,40.778,0,0,0,170.05,0"
                fill="#fff"
              />
              <path
                id="Path_187"
                data-name="Path 187"
                d="M166.693,20.4a204.479,204.479,0,0,0-20.464,1.173A89.345,89.345,0,0,0,144.2,39.347h22.5Z"
                fill="#fff"
              />
              <path
                id="Path_188"
                data-name="Path 188"
                d="M127.345,39.348h13.5a93.266,93.266,0,0,1,1.879-17.362q-5.911.751-11.633,1.85a40.775,40.775,0,0,0-3.742,15.512"
                fill="#fff"
              />
              <path
                id="Path_189"
                data-name="Path 189"
                d="M166.693,82.052V65.01c-6.644-.052-13.19-.407-19.6-1.063a54.339,54.339,0,0,0,6.685,15.46,40.8,40.8,0,0,0,12.914,2.645"
                fill="#fff"
              />
              <path
                id="Path_190"
                data-name="Path 190"
                d="M166.693,0a40.772,40.772,0,0,0-12.914,2.646A54.316,54.316,0,0,0,147.094,18.1c6.409-.656,12.955-1.011,19.6-1.062Z"
                fill="#fff"
              />
              <path
                id="Path_191"
                data-name="Path 191"
                d="M166.693,42.705H144.2a89.345,89.345,0,0,0,2.032,17.774,204.48,204.48,0,0,0,20.464,1.173Z"
                fill="#fff"
              />
              <path
                id="Path_192"
                data-name="Path 192"
                d="M148.473,76.935a64.061,64.061,0,0,1-4.955-13.378q-5.295-.64-10.44-1.563a41.357,41.357,0,0,0,15.4,14.941"
                fill="#fff"
              />
              <path
                id="Path_193"
                data-name="Path 193"
                d="M148.473,5.116a41.367,41.367,0,0,0-15.4,14.941q5.146-.915,10.441-1.562a64.05,64.05,0,0,1,4.955-13.379"
                fill="#fff"
              />
              <path
                id="Path_194"
                data-name="Path 194"
                d="M131.087,58.217q5.713,1.1,11.632,1.849a93.255,93.255,0,0,1-1.879-17.361H127.345a40.761,40.761,0,0,0,3.742,15.512"
                fill="#fff"
              />
              <path
                id="Path_195"
                data-name="Path 195"
                d="M217.2,65.985a14.61,14.61,0,0,1,2.455.222,22.592,22.592,0,0,1,41.279-4.8,17.559,17.559,0,1,1,6.657,33.805H217.2a14.616,14.616,0,0,1,0-29.231"
                fill="#fff"
              />
              <path
                id="Path_196"
                data-name="Path 196"
                d="M64.433,56.566a14.611,14.611,0,0,1,2.455.222,22.592,22.592,0,0,1,41.279-4.8,17.558,17.558,0,1,1,6.657,33.8H64.433a14.615,14.615,0,1,1,0-29.23"
                fill="#fff"
              />
              <path
                id="Path_197"
                data-name="Path 197"
                d="M295.752,326.922a46.864,46.864,0,0,0-29.711-21.808c-21.208-4.944-52.539-12.814-55.132-16.722-3.948-5.95-8.364-39.135-8.364-39.135l-23.112-6.84.883-12.279L165.5,228.226l-.88,12.449-29,8.582s-4.416,33.185-8.365,39.135c-2.592,3.908-33.923,11.778-55.131,16.722a46.862,46.862,0,0,0-29.711,21.808l-5.582,9.448h264.5Z"
                fill="#b1b2b4"
              />
              <path
                id="Path_198"
                data-name="Path 198"
                d="M165.5,228.226l-.88,12.449-29,8.582s-4.416,33.184-8.364,39.135c-2.593,3.908-33.924,11.778-55.132,16.722a46.864,46.864,0,0,0-29.711,21.808l-5.582,9.448H168.512V228.615Z"
                fill="#a6a6a7"
              />
              <path
                id="Path_199"
                data-name="Path 199"
                d="M216.929,149.191c-16.977-23.472-47.845-22.775-47.845-22.775s-30.868-.7-47.845,22.775c0,0-10.136,19.289-4.561,59.959,0,0,1.267,25.563,1.52,28.12S144.8,271.9,151.392,276.08s17.692,3.486,17.692,3.486,11.1.7,17.691-3.486,32.941-36.254,33.2-38.81,1.52-28.12,1.52-28.12c5.575-40.67-4.561-59.959-4.561-59.959"
                fill="#b1b2b4"
              />
              <path
                id="Path_200"
                data-name="Path 200"
                d="M220.461,220.538l5.365-6.2s7.117-20.551,2.725-25.788-8.757,5.567-8.757,5.567Z"
                fill="#b1b2b4"
              />
              <path
                id="Path_201"
                data-name="Path 201"
                d="M117.706,220.538l-5.365-6.2s-7.117-20.551-2.725-25.788,8.757,5.567,8.757,5.567Z"
                fill="#a4a4a8"
              />
              <path
                id="Path_202"
                data-name="Path 202"
                d="M205.975,270.57c-.813-4.281-1.537-8.633-2.108-12.285-6.906,8.105-14.073,15.878-17.092,17.795-6.588,4.183-17.692,3.486-17.692,3.486s-11.1.7-17.692-3.486c-3.018-1.917-10.186-9.69-17.092-17.795-.571,3.652-1.294,8-2.108,12.285,7.5,8.946,15.872,18.174,19.2,20.287,6.589,4.184,17.692,3.486,17.692,3.486s11.1.7,17.692-3.486c3.328-2.113,11.7-11.341,19.2-20.287"
                fill="#979797"
              />
              <path
                id="Path_203"
                data-name="Path 203"
                d="M168.511,126.416c-4.223.041-31.632,1.151-47.273,22.775,0,0-10.135,19.289-4.561,59.959,0,0,1.267,25.563,1.52,28.12S144.8,271.9,151.392,276.08c5.706,3.623,14.786,3.585,17.119,3.51Z"
                fill="#a6a6a7"
              />
              <path
                id="Path_204"
                data-name="Path 204"
                d="M210.349,154c-11.841-23.672-41.265-22.2-41.265-22.2s-29.424-1.475-41.265,22.2c-11.288,22.567,17.548,41.331,41.265,40.2,23.717,1.13,52.553-17.634,41.265-40.2"
                fill="#6d6d70"
              />
              <path
                id="Path_205"
                data-name="Path 205"
                d="M171.14,191.784c-.648,0-1.3-.014-1.939-.046l-.117,0-.118,0c-.642.032-1.289.046-1.939.046-14.7,0-29.945-7.414-36.257-17.63-3.77-6.1-4.021-12.511-.749-19.055,9.928-19.848,33.431-20.854,38.042-20.854.552,0,.868.014.9.016l.121.005.123-.006c.029,0,.344-.015.9-.015,4.611,0,28.113,1.006,38.042,20.854,3.273,6.545,3.022,12.957-.749,19.059-6.313,10.213-21.559,17.626-36.252,17.626Z"
                fill="#dedede"
              />
              <path
                id="Path_206"
                data-name="Path 206"
                d="M171.14,190.553c-.628,0-1.257-.014-1.879-.044l-.132-.005-.222.005q-.936.045-1.88.044c-14.3,0-29.107-7.169-35.21-17.045-3.53-5.714-3.764-11.721-.694-17.857,9.6-19.2,32.456-20.174,36.94-20.174.477,0,.764.01.824.013l.256.007.124-.007c.019,0,.316-.013.837-.013,4.484,0,27.336.973,36.94,20.174,3.07,6.138,2.836,12.147-.7,17.86-6.1,9.875-20.909,17.042-35.2,17.042Z"
                fill="#fff"
              />
              <g id="Group_79" data-name="Group 79" opacity="0.4">
                <g id="Group_78" data-name="Group 78">
                  <g
                    id="Group_77"
                    data-name="Group 77"
                    clip-path="url(#clip-path-3)"
                  >
                    <path
                      id="Path_207"
                      data-name="Path 207"
                      d="M170.7,135.49l.256.006.113-.005c-.375-.01-.7-.014-.961-.014h-.11c.4,0,.648.01.7.013"
                      fill="#a0a0a0"
                    />
                    <path
                      id="Path_208"
                      data-name="Path 208"
                      d="M171.07,190.508l-.132,0-.223,0c-.24.012-.485.01-.727.017.384.011.767.027,1.153.027h0c.261,0,.521-.019.782-.024-.286-.007-.573-.006-.857-.02"
                      fill="#a0a0a0"
                    />
                    <path
                      id="Path_209"
                      data-name="Path 209"
                      d="M133.626,173.507c-3.53-5.714-3.764-11.72-.7-17.857,9.05-18.091,29.854-20,35.98-20.16h-.024c-.06,0-.347-.013-.824-.013-4.484,0-27.336.973-36.94,20.173-3.07,6.137-2.836,12.143.694,17.857,6.1,9.877,20.911,17.045,35.21,17.045.343,0,.683-.015,1.024-.024-14.053-.255-28.434-7.325-34.425-17.021"
                      fill="#a0a0a0"
                    />
                  </g>
                </g>
              </g>
              <path
                id="Path_210"
                data-name="Path 210"
                d="M196.012,171.361a6.214,6.214,0,0,0,3.993-.289,4.341,4.341,0,0,0,2.425-2.215,8.321,8.321,0,0,0-1.916-4.483,11.273,11.273,0,0,1-3.929,3.345,7.76,7.76,0,0,1-3.229.714c-.051,0-.1-.009-.154-.01a6.7,6.7,0,0,1-1.847,4.548,6.866,6.866,0,0,0,3.4,1.487.572.572,0,0,1-.078,1.138.529.529,0,0,1-.08-.006,7.9,7.9,0,0,1-4.075-1.83,8.374,8.374,0,0,1-2.677,1.489,11.747,11.747,0,0,1-1.491.377,2.4,2.4,0,0,0,.08,2.987.571.571,0,1,1-.873.737,3.549,3.549,0,0,1-.614-3.493l-.278.041a22.555,22.555,0,0,0-2.427.439c-1.545.4-3.23,1.44-3.273,2.759a.57.57,0,0,1-.572.552h-.019a.571.571,0,0,1-.552-.59c.058-1.749,1.67-2.942,3.3-3.557-.3-.112-.592-.247-.987-.438a5.293,5.293,0,0,1-2.534-2.605.572.572,0,1,1,1.067-.41,4.144,4.144,0,0,0,1.965,1.985,8.259,8.259,0,0,0,2.613.835.525.525,0,0,1,.157.067c.369-.061.739-.117,1.1-.169a17.343,17.343,0,0,0,2.981-.6,6.376,6.376,0,0,0,4.581-5.873,4.92,4.92,0,0,1-2.047-.882.572.572,0,1,1,.694-.909c1.453,1.106,3.806.933,5.384.186a10.124,10.124,0,0,0,3.5-3,9.916,9.916,0,0,0-5.869-3.511.572.572,0,1,1,.227-1.122,11.161,11.161,0,0,1,6.294,3.623,10.137,10.137,0,0,0,.143-8.856,12.948,12.948,0,0,0-6.875-6.2,5.565,5.565,0,0,1-.774,3.571c-.108.179-.239.343-.362.511a12.038,12.038,0,0,1,6.494,4.3.57.57,0,0,1-.123.8.56.56,0,0,1-.338.112.57.57,0,0,1-.46-.235,10.976,10.976,0,0,0-6.368-4.007l-.009,0c-.5.526-1.047,1.019-1.586,1.5l-.33.293a9.155,9.155,0,0,0-2.526,3.089,8.3,8.3,0,0,0-.418,2.816c0,.041-.006.082-.006.121a7.546,7.546,0,0,1,5.763,2.991.572.572,0,1,1-.927.67,6.363,6.363,0,0,0-4.9-2.523,8.8,8.8,0,0,1-.17,1.131,7.147,7.147,0,0,1-2.334,3.669,8.6,8.6,0,0,0,3.939,3.752.571.571,0,0,1-.248,1.086.543.543,0,0,1-.247-.058,9.791,9.791,0,0,1-4.367-4.071,9.546,9.546,0,0,1-4.233,1.579,4.254,4.254,0,0,1-2.055,1.936,7.228,7.228,0,0,1-3.1.635l-.11,0a8.243,8.243,0,0,1-4.065-.927v.544a10.825,10.825,0,0,0,.233,2.3c.011.014.028.021.037.038a6.74,6.74,0,0,0,6.116,3.213.571.571,0,1,1,.136,1.134,6.021,6.021,0,0,1-.746.045,7.42,7.42,0,0,1-4.59-1.707,14.283,14.283,0,0,0,11.926,7.6l.045,0a3.815,3.815,0,0,1-.489-.453,3.553,3.553,0,0,1-.737-3.377.571.571,0,1,1,1.091.339,2.413,2.413,0,0,0,.515,2.293,3.307,3.307,0,0,0,2.364,1.038,16.443,16.443,0,0,0,8.2-3.588,7.727,7.727,0,0,1-4.287-1.94.572.572,0,1,1,.782-.835,6.877,6.877,0,0,0,5,1.694.588.588,0,0,1,.181.021,10.361,10.361,0,0,0,6.6-6.205,8.694,8.694,0,0,0,.356-1.64,6.528,6.528,0,0,1-1.938,1.25,7.379,7.379,0,0,1-4.74.345.572.572,0,0,1,.294-1.106"
                fill="#d6a295"
              />
              <path
                id="Path_211"
                data-name="Path 211"
                d="M179.743,162.816a9.339,9.339,0,0,0-5.555-.644c-1.919.369-3.476.755-4.532,1.872v4.98a6.727,6.727,0,0,0,4.078,1.112,6.456,6.456,0,0,0,2.7-.521,3.332,3.332,0,0,0,1.32-1.079,6.38,6.38,0,0,1-2.932-2.366.572.572,0,1,1,.965-.614,5.3,5.3,0,0,0,2.723,2.057c.011,0,.019-.011.03-.011,3.211-.232,6.2-2.475,6.815-5.108a11.441,11.441,0,0,0,.216-2.172c.01-.277.021-.557.038-.839-.022-.011-.047-.007-.069-.021a16.766,16.766,0,0,0-9.575-2.738.572.572,0,0,1-.02-1.144,17.775,17.775,0,0,1,9.814,2.676,5.957,5.957,0,0,1,.31-1.134,10.083,10.083,0,0,1,2.827-3.516l.331-.3.084-.075c-2.131-2.118-4.933-4.057-10.793-4.057a.571.571,0,1,1,0-1.143c6.308,0,9.329,2.121,11.638,4.427a9.361,9.361,0,0,0,1.607-1.863c.632-1.036.962-2.647.336-3.6-.174-.222-.365-.433-.552-.646a.516.516,0,0,1-.119.028,3.069,3.069,0,0,0-2.7,1.687.572.572,0,0,1-.53.358.583.583,0,0,1-.215-.042.571.571,0,0,1-.316-.744,4.072,4.072,0,0,1,2.921-2.289,19.033,19.033,0,0,0-7.6-4.4,13.745,13.745,0,0,0-9.346.115,5.133,5.133,0,0,0-2.85,3.592,16.312,16.312,0,0,1,13.223-.528.572.572,0,0,1-.417,1.066,14.961,14.961,0,0,0-13.261,1.023,15.856,15.856,0,0,0-.686,4.028v2.229a19.424,19.424,0,0,1,10.156-.109.571.571,0,1,1-.272,1.11,18.286,18.286,0,0,0-9.884.186v8.881a11.2,11.2,0,0,1,4.315-1.491,10.539,10.539,0,0,1,6.25.729.572.572,0,0,1-.478,1.039"
                fill="#d6a295"
              />
              <path
                id="Path_212"
                data-name="Path 212"
                d="M158.355,152.361a19.382,19.382,0,0,1,10.156.11v-2.229a15.846,15.846,0,0,0-.685-4.028,14.97,14.97,0,0,0-13.262-1.023.572.572,0,1,1-.417-1.065,16.3,16.3,0,0,1,13.223.526,5.136,5.136,0,0,0-2.85-3.591,11.21,11.21,0,0,0-4.516-.87,16.647,16.647,0,0,0-4.829.754,19.056,19.056,0,0,0-7.6,4.4,4.069,4.069,0,0,1,2.92,2.291.573.573,0,0,1-.318.744.584.584,0,0,1-.213.041.572.572,0,0,1-.53-.359,3.066,3.066,0,0,0-2.7-1.685.608.608,0,0,1-.119-.029c-.187.214-.378.424-.553.646a3.741,3.741,0,0,0,.337,3.6,9.339,9.339,0,0,0,1.608,1.863c2.308-2.306,5.326-4.427,11.637-4.427a.571.571,0,1,1,0,1.143c-5.861,0-8.663,1.939-10.792,4.056.026.024.052.049.078.071l.337.3a10.106,10.106,0,0,1,2.826,3.517,5.926,5.926,0,0,1,.31,1.133,17.858,17.858,0,0,1,9.814-2.676.573.573,0,0,1,.562.582.6.6,0,0,1-.582.563,16.816,16.816,0,0,0-9.576,2.739c-.021.014-.046.01-.067.021.017.28.028.561.038.838a11.344,11.344,0,0,0,.214,2.171c.611,2.634,3.6,4.877,6.816,5.109.011,0,.019.009.03.011a5.291,5.291,0,0,0,2.723-2.058.572.572,0,0,1,.965.615,6.386,6.386,0,0,1-2.932,2.366,3.315,3.315,0,0,0,1.32,1.078,6.2,6.2,0,0,0,2.7.521,6.711,6.711,0,0,0,4.079-1.112v-4.979c-1.055-1.118-2.612-1.5-4.532-1.872a9.338,9.338,0,0,0-5.555.644.572.572,0,1,1-.477-1.039,10.526,10.526,0,0,1,6.249-.729,11.207,11.207,0,0,1,4.315,1.49v-8.88a18.282,18.282,0,0,0-9.883-.187.567.567,0,0,1-.692-.418.573.573,0,0,1,.419-.692"
                fill="#d6a295"
              />
              <path
                id="Path_213"
                data-name="Path 213"
                d="M162.125,176.449a6.71,6.71,0,0,0,6.115-3.213c.011-.016.027-.025.039-.04a10.752,10.752,0,0,0,.232-2.294v-.55a8.241,8.241,0,0,1-4.065.927h-.111a7.255,7.255,0,0,1-3.093-.633,4.256,4.256,0,0,1-2.056-1.938,9.533,9.533,0,0,1-4.232-1.578,9.819,9.819,0,0,1-4.367,4.072.571.571,0,0,1-.5-1.029,8.6,8.6,0,0,0,3.94-3.752,7.139,7.139,0,0,1-2.333-3.669,8.317,8.317,0,0,1-.171-1.13,6.348,6.348,0,0,0-4.9,2.522.574.574,0,0,1-.464.237.572.572,0,0,1-.463-.907,7.531,7.531,0,0,1,5.764-2.991c0-.04-.005-.081-.007-.121a8.305,8.305,0,0,0-.418-2.816,9.139,9.139,0,0,0-2.527-3.089l-.333-.3c-.538-.479-1.082-.969-1.583-1.494l-.008,0a10.976,10.976,0,0,0-6.368,4.008.573.573,0,0,1-.8.123.573.573,0,0,1-.122-.8,12.035,12.035,0,0,1,6.494-4.3c-.124-.168-.253-.332-.362-.51a5.568,5.568,0,0,1-.774-3.571,12.933,12.933,0,0,0-6.874,6.195,10.139,10.139,0,0,0,.142,8.857,11.168,11.168,0,0,1,6.294-3.624.572.572,0,0,1,.228,1.121,9.916,9.916,0,0,0-5.87,3.512,10.134,10.134,0,0,0,3.5,3c1.576.747,3.932.921,5.385-.186a.572.572,0,1,1,.693.909,4.956,4.956,0,0,1-2.047.883,6.379,6.379,0,0,0,4.582,5.873,17.427,17.427,0,0,0,2.98.6c.363.052.732.108,1.1.168a.58.58,0,0,1,.158-.066,8.266,8.266,0,0,0,2.614-.835,4.15,4.15,0,0,0,1.964-1.985.572.572,0,1,1,1.068.411,5.308,5.308,0,0,1-2.534,2.6c-.4.191-.689.325-.989.438,1.629.615,3.242,1.808,3.3,3.557a.572.572,0,0,1-.552.591h-.02a.572.572,0,0,1-.57-.553c-.044-1.319-1.728-2.354-3.274-2.759a22.529,22.529,0,0,0-2.428-.439l-.277-.04a3.545,3.545,0,0,1-.613,3.491.574.574,0,0,1-.438.2.573.573,0,0,1-.437-.941,2.4,2.4,0,0,0,.081-2.986,11.892,11.892,0,0,1-1.492-.377,8.366,8.366,0,0,1-2.677-1.489,7.9,7.9,0,0,1-4.074,1.831.549.549,0,0,1-.08.006.572.572,0,0,1-.079-1.138,6.883,6.883,0,0,0,3.4-1.488,6.719,6.719,0,0,1-1.847-4.549c-.052,0-.1.01-.155.01a7.74,7.74,0,0,1-3.228-.713,11.26,11.26,0,0,1-3.929-3.346,8.33,8.33,0,0,0-1.916,4.485,4.335,4.335,0,0,0,2.425,2.213,6.22,6.22,0,0,0,3.995.291.571.571,0,1,1,.291,1.1,7.394,7.394,0,0,1-4.741-.346,6.5,6.5,0,0,1-1.936-1.249,8.68,8.68,0,0,0,.357,1.64,10.36,10.36,0,0,0,6.6,6.205.5.5,0,0,1,.181-.021A6.873,6.873,0,0,0,147.915,177a.572.572,0,1,1,.781.835,7.734,7.734,0,0,1-4.287,1.94,16.418,16.418,0,0,0,8.2,3.588,3.32,3.32,0,0,0,2.366-1.038,2.418,2.418,0,0,0,.513-2.293.572.572,0,1,1,1.092-.34,3.556,3.556,0,0,1-.737,3.378,3.745,3.745,0,0,1-.489.452h.043a14.284,14.284,0,0,0,11.929-7.6,7.416,7.416,0,0,1-4.591,1.708,6.193,6.193,0,0,1-.745-.044.571.571,0,1,1,.135-1.135"
                fill="#d6a295"
              />
              <g id="Group_82" data-name="Group 82" opacity="0.3">
                <g id="Group_81" data-name="Group 81">
                  <g
                    id="Group_80"
                    data-name="Group 80"
                    clip-path="url(#clip-path-4)"
                  >
                    <path
                      id="Path_214"
                      data-name="Path 214"
                      d="M200.891,147.1l-30.434,43.432c.228,0,.455.016.683.016h0a44.97,44.97,0,0,0,5.282-.319l27.642-39.448a32.451,32.451,0,0,0-3.177-3.681"
                      fill="#a4a4a8"
                    />
                  </g>
                </g>
              </g>
              <g id="Group_85" data-name="Group 85" opacity="0.3">
                <g id="Group_84" data-name="Group 84">
                  <g
                    id="Group_83"
                    data-name="Group 83"
                    clip-path="url(#clip-path-5)"
                  >
                    <path
                      id="Path_215"
                      data-name="Path 215"
                      d="M165.521,190.506l32.316-46.118a37.166,37.166,0,0,0-6.631-4.116l-34.4,49.1a46.836,46.836,0,0,0,8.72,1.135"
                      fill="#a4a4a8"
                    />
                  </g>
                </g>
              </g>
              <g id="Group_88" data-name="Group 88" opacity="0.3">
                <g id="Group_87" data-name="Group 87">
                  <g
                    id="Group_86"
                    data-name="Group 86"
                    clip-path="url(#clip-path-6)"
                  >
                    <path
                      id="Path_216"
                      data-name="Path 216"
                      d="M169.267,135.49l-.124.006-.256-.006c-.06,0-.347-.013-.824-.013a52.305,52.305,0,0,0-13.234,1.854l-24.037,34.3a21.165,21.165,0,0,0,1.025,1.872,29.016,29.016,0,0,0,6.522,7.186l31.684-45.216c-.466,0-.738.012-.756.013"
                      fill="#a4a4a8"
                    />
                  </g>
                </g>
              </g>
              <path
                id="Path_217"
                data-name="Path 217"
                d="M168.511,279.59c-2.333.075-11.413.113-17.119-3.51-3.019-1.917-10.187-9.69-17.093-17.795-.57,3.652-1.294,8-2.108,12.285,7.5,8.946,15.873,18.174,19.2,20.287,5.706,3.623,14.786,3.585,17.119,3.51Z"
                fill="#8f8f8f"
              />
              <path
                id="Path_218"
                data-name="Path 218"
                d="M149.048,88.925V99.968l-8.956,5.1v7.961"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_219"
                data-name="Path 219"
                d="M142.541,115.481a2.45,2.45,0,1,1-2.449-2.449A2.45,2.45,0,0,1,142.541,115.481Z"
                fill="none"
                stroke="#6d6d70"
                stroke-width="1.5"
              />
              <line
                id="Line_18"
                data-name="Line 18"
                y2="10.342"
                transform="translate(154.661 82.413)"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_220"
                data-name="Path 220"
                d="M159.3,82.413V92.755l1.6,1.193v13.4"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_19"
                data-name="Line 19"
                y2="7.348"
                transform="translate(145.465 102.009)"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_221"
                data-name="Path 221"
                d="M149.048,88.762l.83-.581v-6.7"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_222"
                data-name="Path 222"
                d="M157.111,99.559a2.449,2.449,0,1,1-2.449-2.449A2.449,2.449,0,0,1,157.111,99.559Z"
                fill="none"
                stroke="#6d6d70"
                stroke-width="1.5"
              />
              <line
                id="Line_20"
                data-name="Line 20"
                y1="16.594"
                transform="translate(140.092 123.135)"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_223"
                data-name="Path 223"
                d="M164.51,133.58V119.972l-9.849-5.035V102.009"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_224"
                data-name="Path 224"
                d="M149.048,106.908v15.82l-3.582,2.308v12.041"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_21"
                data-name="Line 21"
                y1="4.116"
                transform="translate(154.661 129.464)"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_22"
                data-name="Line 22"
                y1="6.705"
                transform="translate(154.661 118.849)"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_23"
                data-name="Line 23"
                y2="2.419"
                transform="translate(160.897 111.716)"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_225"
                data-name="Path 225"
                d="M194.325,114.135a2.45,2.45,0,1,1-2.449-2.449A2.45,2.45,0,0,1,194.325,114.135Z"
                fill="none"
                stroke="#6d6d70"
                stroke-width="1.5"
              />
              <path
                id="Path_226"
                data-name="Path 226"
                d="M180.615,99.559a2.45,2.45,0,1,1-2.45-2.449A2.449,2.449,0,0,1,180.615,99.559Z"
                fill="none"
                stroke="#6d6d70"
                stroke-width="1.5"
              />
              <line
                id="Line_24"
                data-name="Line 24"
                y2="10.342"
                transform="translate(178.165 82.413)"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_227"
                data-name="Path 227"
                d="M182.8,82.413V92.755l1.6,1.193v13.4"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_228"
                data-name="Path 228"
                d="M188.014,135.811V119.972l-9.849-5.035V102.009"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_25"
                data-name="Line 25"
                y2="7.348"
                transform="translate(168.715 102.554)"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_229"
                data-name="Path 229"
                d="M172.552,106.908v15.82l-3.582,2.308v7.984"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_26"
                data-name="Line 26"
                y1="4.116"
                transform="translate(178.165 129.464)"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_27"
                data-name="Line 27"
                y1="6.705"
                transform="translate(178.165 118.849)"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_230"
                data-name="Path 230"
                d="M172.552,88.762l.83-.581v-6.7"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_28"
                data-name="Line 28"
                y2="2.419"
                transform="translate(184.401 111.716)"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_29"
                data-name="Line 29"
                y2="4.093"
                transform="translate(164.006 82.413)"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_231"
                data-name="Path 231"
                d="M164.006,89.855l4.506,1.581V97"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_232"
                data-name="Path 232"
                d="M164.51,116.368v-11.3l8.042-5.1V88.925"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <rect
                id="Rectangle_57"
                data-name="Rectangle 57"
                width="2.312"
                height="4.067"
                transform="translate(148.722 36.595)"
                fill="#979797"
              />
              <rect
                id="Rectangle_58"
                data-name="Rectangle 58"
                width="2.312"
                height="4.067"
                transform="translate(153.431 36.595)"
                fill="#979797"
              />
              <rect
                id="Rectangle_59"
                data-name="Rectangle 59"
                width="2.312"
                height="4.067"
                transform="translate(158.14 36.595)"
                fill="#979797"
              />
              <rect
                id="Rectangle_60"
                data-name="Rectangle 60"
                width="2.312"
                height="4.067"
                transform="translate(162.85 36.595)"
                fill="#979797"
              />
              <rect
                id="Rectangle_61"
                data-name="Rectangle 61"
                width="2.312"
                height="4.067"
                transform="translate(167.559 36.595)"
                fill="#979797"
              />
              <rect
                id="Rectangle_62"
                data-name="Rectangle 62"
                width="2.312"
                height="4.067"
                transform="translate(172.268 36.595)"
                fill="#979797"
              />
              <rect
                id="Rectangle_63"
                data-name="Rectangle 63"
                width="2.312"
                height="4.067"
                transform="translate(176.978 36.595)"
                fill="#979797"
              />
              <rect
                id="Rectangle_64"
                data-name="Rectangle 64"
                width="2.312"
                height="4.067"
                transform="translate(181.687 36.595)"
                fill="#979797"
              />
              <rect
                id="Rectangle_65"
                data-name="Rectangle 65"
                width="2.312"
                height="4.067"
                transform="translate(148.722 78.722)"
                fill="#979797"
              />
              <rect
                id="Rectangle_66"
                data-name="Rectangle 66"
                width="2.312"
                height="4.067"
                transform="translate(153.431 78.722)"
                fill="#979797"
              />
              <rect
                id="Rectangle_67"
                data-name="Rectangle 67"
                width="2.312"
                height="4.067"
                transform="translate(158.14 78.722)"
                fill="#979797"
              />
              <rect
                id="Rectangle_68"
                data-name="Rectangle 68"
                width="2.312"
                height="4.067"
                transform="translate(162.85 78.722)"
                fill="#979797"
              />
              <rect
                id="Rectangle_69"
                data-name="Rectangle 69"
                width="2.312"
                height="4.067"
                transform="translate(167.559 78.722)"
                fill="#979797"
              />
              <rect
                id="Rectangle_70"
                data-name="Rectangle 70"
                width="2.312"
                height="4.067"
                transform="translate(172.268 78.722)"
                fill="#979797"
              />
              <rect
                id="Rectangle_71"
                data-name="Rectangle 71"
                width="2.312"
                height="4.067"
                transform="translate(176.978 78.722)"
                fill="#979797"
              />
              <rect
                id="Rectangle_72"
                data-name="Rectangle 72"
                width="2.312"
                height="4.067"
                transform="translate(181.687 78.722)"
                fill="#979797"
              />
              <rect
                id="Rectangle_73"
                data-name="Rectangle 73"
                width="4.067"
                height="2.312"
                transform="translate(185.647 42.054)"
                fill="#979797"
              />
              <rect
                id="Rectangle_74"
                data-name="Rectangle 74"
                width="4.067"
                height="2.312"
                transform="translate(185.647 46.763)"
                fill="#979797"
              />
              <rect
                id="Rectangle_75"
                data-name="Rectangle 75"
                width="4.067"
                height="2.312"
                transform="translate(185.647 51.472)"
                fill="#979797"
              />
              <rect
                id="Rectangle_76"
                data-name="Rectangle 76"
                width="4.067"
                height="2.312"
                transform="translate(185.647 56.181)"
                fill="#979797"
              />
              <rect
                id="Rectangle_77"
                data-name="Rectangle 77"
                width="4.067"
                height="2.312"
                transform="translate(185.647 60.891)"
                fill="#979797"
              />
              <rect
                id="Rectangle_78"
                data-name="Rectangle 78"
                width="4.067"
                height="2.312"
                transform="translate(185.647 65.6)"
                fill="#979797"
              />
              <rect
                id="Rectangle_79"
                data-name="Rectangle 79"
                width="4.067"
                height="2.312"
                transform="translate(185.647 70.309)"
                fill="#979797"
              />
              <rect
                id="Rectangle_80"
                data-name="Rectangle 80"
                width="4.067"
                height="2.312"
                transform="translate(185.647 75.018)"
                fill="#979797"
              />
              <rect
                id="Rectangle_81"
                data-name="Rectangle 81"
                width="4.067"
                height="2.312"
                transform="translate(143.007 42.054)"
                fill="#979797"
              />
              <rect
                id="Rectangle_82"
                data-name="Rectangle 82"
                width="4.067"
                height="2.312"
                transform="translate(143.007 46.763)"
                fill="#979797"
              />
              <rect
                id="Rectangle_83"
                data-name="Rectangle 83"
                width="4.067"
                height="2.312"
                transform="translate(143.007 51.472)"
                fill="#979797"
              />
              <rect
                id="Rectangle_84"
                data-name="Rectangle 84"
                width="4.067"
                height="2.312"
                transform="translate(143.007 56.181)"
                fill="#979797"
              />
              <rect
                id="Rectangle_85"
                data-name="Rectangle 85"
                width="4.067"
                height="2.312"
                transform="translate(143.007 60.891)"
                fill="#979797"
              />
              <rect
                id="Rectangle_86"
                data-name="Rectangle 86"
                width="4.067"
                height="2.312"
                transform="translate(143.007 65.6)"
                fill="#979797"
              />
              <rect
                id="Rectangle_87"
                data-name="Rectangle 87"
                width="4.067"
                height="2.312"
                transform="translate(143.007 70.309)"
                fill="#979797"
              />
              <rect
                id="Rectangle_88"
                data-name="Rectangle 88"
                width="4.067"
                height="2.312"
                transform="translate(143.007 75.018)"
                fill="#979797"
              />
              <rect
                id="Rectangle_89"
                data-name="Rectangle 89"
                width="39.273"
                height="39.272"
                transform="translate(146.724 40.056)"
                fill="#8f8f8f"
              />
              <path
                id="Path_233"
                data-name="Path 233"
                d="M154.4,42.8l-4.936,5.187V76.587h33.792V42.8Z"
                fill="#b1b2b4"
              />
              <path
                id="Path_234"
                data-name="Path 234"
                d="M146.724,79.328l2.74-2.74h33.792L186,79.328Z"
                fill="#a6a6a7"
              />
              <path
                id="Path_235"
                data-name="Path 235"
                d="M186,40.056l-2.741,2.74H149.465l-2.741-2.74Z"
                fill="#a6a6a7"
              />
              <path
                id="Path_236"
                data-name="Path 236"
                d="M146.724,40.056l2.74,2.74V76.588l-2.74,2.74Z"
                fill="#979797"
              />
            </g>
          </g>
          <text
            id="CPU"
            transform="translate(153.025 64.501)"
            fill="#fff"
            font-size="14.793"
            font-family="SegoeUI, Segoe UI"
          >
            <tspan x="0" y="0" letter-spacing="0.024em">
              CP
            </tspan>
            <tspan y="0">U</tspan>
          </text>
          <g id="Group_104" data-name="Group 104">
            <g id="Group_103" data-name="Group 103" clip-path="url(#clip-path)">
              <path
                id="Path_237"
                data-name="Path 237"
                d="M184.4,102.7l7.474,2.985v6.034"
                fill="none"
                stroke="#6d6d70"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_238"
                data-name="Path 238"
                d="M306.867,274.25l-9.212-11.2L293.2,266.71l-.945-5.69L277.945,263.4l.945,5.691-5.4-2.027-5.1,13.58,5.4,2.027-4.456,3.664,9.213,11.2,4.455-3.663.945,5.69,14.31-2.377-.945-5.69,5.4,2.027,5.1-13.581-5.4-2.026Zm-8.4,9.928a11.065,11.065,0,1,1-6.472-14.247,11.065,11.065,0,0,1,6.472,14.247"
                fill="#b1b2b4"
              />
              <path
                id="Path_239"
                data-name="Path 239"
                d="M295.176,282.944a7.555,7.555,0,1,1-4.419-9.728,7.555,7.555,0,0,1,4.419,9.728"
                fill="#8f8f8f"
              />
              <path
                id="Path_240"
                data-name="Path 240"
                d="M223.733,88.072l-7.143-8.686-3.454,2.84-.733-4.412-11.094,1.843.733,4.412L197.855,82.5,193.9,93.026,198.09,94.6l-3.454,2.84,7.143,8.686,3.454-2.84.733,4.411,11.094-1.842-.733-4.412,4.187,1.572,3.951-10.529-4.186-1.572Zm-6.517,7.7A8.578,8.578,0,1,1,212.2,84.723a8.579,8.579,0,0,1,5.018,11.046"
                fill="#b1b2b4"
              />
              <path
                id="Path_241"
                data-name="Path 241"
                d="M214.668,94.813a5.857,5.857,0,1,1-3.426-7.542,5.858,5.858,0,0,1,3.426,7.542"
                fill="#8f8f8f"
              />
              <path
                id="Path_242"
                data-name="Path 242"
                d="M117.512,283.427l-13.655-6.395-2.543,5.43-3.431-4.917-12.366,8.628,3.432,4.917-5.974.513,1.289,15.023,5.974-.513-2.542,5.43,13.655,6.395,2.542-5.43,3.431,4.917L119.69,308.8l-3.431-4.917,5.973-.513-1.289-15.022-5.974.512ZM114.063,296.5a11.5,11.5,0,1,1-12.443-10.476A11.5,11.5,0,0,1,114.063,296.5"
                fill="#8f8f8f"
              />
              <path
                id="Path_243"
                data-name="Path 243"
                d="M110.428,296.813a7.853,7.853,0,1,1-8.5-7.153,7.853,7.853,0,0,1,8.5,7.153"
                fill="#8f8f8f"
              />
              <path
                id="Path_244"
                data-name="Path 244"
                d="M262.648,303.222l6.335-.893-1.832-13-6.335.893a21.279,21.279,0,0,0-1.752-2.967l3.85-5.113-10.488-7.9-3.851,5.114a21.177,21.177,0,0,0-3.335-.865l-.893-6.335-13,1.832.892,6.335a21.231,21.231,0,0,0-2.966,1.753l-5.114-3.85-7.9,10.488,5.113,3.85a21.326,21.326,0,0,0-.864,3.336l-6.335.892,1.832,13,6.335-.893a21.186,21.186,0,0,0,1.753,2.967l-3.851,5.113,10.489,7.9,3.85-5.114a21.177,21.177,0,0,0,3.335.865l.893,6.335,13-1.832-.893-6.335a21.118,21.118,0,0,0,2.966-1.753l5.114,3.85,7.9-10.488-5.113-3.85a21.232,21.232,0,0,0,.864-3.335m-19.2,9.59a13.382,13.382,0,1,1,11.384-15.118,13.4,13.4,0,0,1-11.384,15.118"
                fill="#8f8f8f"
              />
              <path
                id="Path_245"
                data-name="Path 245"
                d="M245.506,299.712a3.929,3.929,0,1,1-3.775-4.078,3.929,3.929,0,0,1,3.775,4.078"
                fill="#8f8f8f"
              />
              <path
                id="Path_246"
                data-name="Path 246"
                d="M76.584,284.562l6.391-.294-.6-13.115-6.391.293a21.392,21.392,0,0,0-1.466-3.118L78.83,263.6l-9.7-8.848-4.314,4.729a21.151,21.151,0,0,0-3.239-1.174l-.294-6.391-13.115.6.293,6.391a21.187,21.187,0,0,0-3.118,1.466l-4.729-4.314-8.848,9.7,4.729,4.313a21.166,21.166,0,0,0-1.174,3.24l-6.391.293.6,13.115,6.391-.293a21.09,21.09,0,0,0,1.466,3.118l-4.314,4.729,9.7,8.848,4.314-4.729a21.226,21.226,0,0,0,3.239,1.175l.293,6.39,13.116-.6-.294-6.39a21.2,21.2,0,0,0,3.118-1.467l4.729,4.314,8.848-9.7L75.409,287.8a21.264,21.264,0,0,0,1.175-3.239M56.566,292.3A13.382,13.382,0,1,1,69.32,278.323,13.4,13.4,0,0,1,56.566,292.3"
                fill="#b1b2b4"
              />
              <path
                id="Path_247"
                data-name="Path 247"
                d="M59.847,279.457a3.93,3.93,0,1,1-3.375-4.414,3.93,3.93,0,0,1,3.375,4.414"
                fill="#8f8f8f"
              />
              <path
                id="Path_248"
                data-name="Path 248"
                d="M135.208,93.395l4.33-.2-.408-8.886-4.33.2a14.362,14.362,0,0,0-.994-2.113l2.923-3.2-6.572-6-2.922,3.2a14.386,14.386,0,0,0-2.195-.8l-.2-4.329-8.886.407.2,4.33a14.36,14.36,0,0,0-2.113.994l-3.2-2.923-5.995,6.572,3.2,2.922a14.46,14.46,0,0,0-.795,2.195l-4.33.2.408,8.886,4.331-.2a14.249,14.249,0,0,0,.992,2.113l-2.923,3.2,6.572,6,2.923-3.2a14.383,14.383,0,0,0,2.195.795l.2,4.33,8.885-.408-.2-4.329a14.5,14.5,0,0,0,2.112-.994l3.2,2.923,5.995-6.572-3.2-2.923a14.413,14.413,0,0,0,.8-2.194m-13.562,5.246a9.067,9.067,0,1,1,8.64-9.473,9.076,9.076,0,0,1-8.64,9.473"
                fill="#b1b2b4"
              />
              <path
                id="Path_249"
                data-name="Path 249"
                d="M123.869,89.936a2.662,2.662,0,1,1-2.287-2.991,2.663,2.663,0,0,1,2.287,2.991"
                fill="#8f8f8f"
              />
              <path
                id="Path_250"
                data-name="Path 250"
                d="M221.18,293.209c2.29.769,4.864,1.567,7.637,2.381a13.365,13.365,0,0,1,25.825,6.808c2.658.648,5.269,1.273,7.78,1.867.079-.347.165-.692.226-1.044l6.335-.893-1.832-13-6.335.893a21.326,21.326,0,0,0-1.752-2.966l3.85-5.114-10.488-7.9-3.851,5.113a21.175,21.175,0,0,0-3.335-.864l-.893-6.335-13,1.832.892,6.335a21.324,21.324,0,0,0-2.966,1.752l-5.114-3.85-7.9,10.488,5.113,3.851c-.073.211-.128.43-.2.644"
                fill="#fff"
              />
              <path
                id="Path_251"
                data-name="Path 251"
                d="M245.451,300.106a3.624,3.624,0,0,0,.055-.394,3.919,3.919,0,0,0-7.573-1.571c2.458.66,4.98,1.317,7.518,1.965"
                fill="#b1b2b4"
              />
              <path
                id="Path_252"
                data-name="Path 252"
                d="M241.414,260.351l-2.452-4.247,2.452-4.247h4.9l2.452,4.247-2.452,4.247Z"
                fill="#8f8f8f"
              />
              <path
                id="Path_253"
                data-name="Path 253"
                d="M208.711,121.128,207,118.157l1.715-2.971h3.431l1.715,2.971-1.715,2.971Z"
                fill="#fff"
              />
              <path
                id="Path_254"
                data-name="Path 254"
                d="M264.1,47.336l-1.715-2.971,1.715-2.971h3.431l1.715,2.971-1.715,2.971Z"
                fill="#fff"
              />
              <path
                id="Path_255"
                data-name="Path 255"
                d="M110.388,41.6l-1.715-2.971,1.715-2.971h3.431l1.715,2.971L113.819,41.6Z"
                fill="#fff"
              />
              <path
                id="Path_256"
                data-name="Path 256"
                d="M116.852,122l-1.715-2.971,1.715-2.971h3.431L122,119.025,120.283,122Z"
                fill="#fff"
              />
              <path
                id="Path_257"
                data-name="Path 257"
                d="M92.3,267.742,89.846,263.5l2.452-4.247h4.9l2.452,4.247L97.2,267.742Z"
                fill="#8f8f8f"
              />
              <path
                id="Path_258"
                data-name="Path 258"
                d="M298.055,313.551l-4.553-1.822-.7-4.854,3.854-3.032,4.553,1.822.7,4.854Z"
                fill="#b1b2b4"
              />
              <path
                id="Path_259"
                data-name="Path 259"
                d="M36.416,320.03l-4.553-1.822-.7-4.854,3.854-3.032,4.553,1.822.7,4.854Z"
                fill="#b1b2b4"
              />
              <path
                id="Path_260"
                data-name="Path 260"
                d="M83.894,302.308c2.511-.613,5.059-1.245,7.6-1.89a11.626,11.626,0,0,1-.349-1.95,11.5,11.5,0,0,1,22.507-4.179c2.893-.9,5.462-1.78,7.579-2.6l-.287-3.345-5.974.512,2.543-5.43-13.655-6.394-2.543,5.43-3.431-4.917-12.365,8.628,3.431,4.917-5.974.513Z"
                fill="#fff"
              />
              <path
                id="Path_261"
                data-name="Path 261"
                d="M95.023,299.513c5.332-1.38,10.522-2.793,15.135-4.161a7.848,7.848,0,0,0-15.135,4.161"
                fill="#b1b2b4"
              />
              <path
                id="Path_262"
                data-name="Path 262"
                d="M55.944,290.086a11.15,11.15,0,0,1-.5-22.287c.171-.008.345-.012.518-.012a11.15,11.15,0,0,1,.505,22.287c-.172.008-.347.012-.52.012m.015-20.066c-.137,0-.274,0-.412.01a8.9,8.9,0,1,0,.412-.01"
                fill="#8f8f8f"
              />
              <path
                id="Path_263"
                data-name="Path 263"
                d="M52.6,215.934a2.45,2.45,0,1,1-2.449-2.449A2.449,2.449,0,0,1,52.6,215.934Z"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_30"
                data-name="Line 30"
                y1="16.594"
                transform="translate(35.584 239.51)"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_264"
                data-name="Path 264"
                d="M59,256.1V236.346l-9.849-5.035V218.383"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_265"
                data-name="Path 265"
                d="M44.54,223.282V239.1l-3.582,2.308v7.4"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_31"
                data-name="Line 31"
                y1="6.705"
                transform="translate(49.154 235.223)"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_32"
                data-name="Line 32"
                y2="2.419"
                transform="translate(56.39 228.091)"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_266"
                data-name="Path 266"
                d="M282.161,250.408V239.365l8.956-5.1V226.3"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_267"
                data-name="Path 267"
                d="M288.667,223.851a2.45,2.45,0,1,1,2.449,2.45A2.449,2.449,0,0,1,288.667,223.851Z"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_33"
                data-name="Line 33"
                y1="10.342"
                transform="translate(276.547 246.578)"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_268"
                data-name="Path 268"
                d="M271.912,275.752V246.577l-1.6-1.193v-13.4"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_34"
                data-name="Line 34"
                y1="7.348"
                transform="translate(285.743 229.976)"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_269"
                data-name="Path 269"
                d="M282.161,250.57l-.83.581v14.225"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_270"
                data-name="Path 270"
                d="M274.1,239.773a2.45,2.45,0,1,1,2.449,2.449A2.449,2.449,0,0,1,274.1,239.773Z"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_35"
                data-name="Line 35"
                y1="7.348"
                transform="translate(262.494 229.431)"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_36"
                data-name="Line 36"
                y1="4.093"
                transform="translate(267.203 252.827)"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_271"
                data-name="Path 271"
                d="M267.2,249.477,262.7,247.9v-5.562"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_272"
                data-name="Path 272"
                d="M36.293,173.111H3.374A3.373,3.373,0,0,0,0,176.484v60.4a3.373,3.373,0,0,0,3.374,3.373H36.293a3.373,3.373,0,0,0,3.373-3.373v-60.4a3.373,3.373,0,0,0-3.373-3.373"
                fill="#8f8f8f"
              />
              <rect
                id="Rectangle_91"
                data-name="Rectangle 91"
                width="36"
                height="53.625"
                transform="translate(1.833 178.065)"
                fill="#fff"
              />
              <rect
                id="Rectangle_92"
                data-name="Rectangle 92"
                width="1"
                height="53.625"
                transform="translate(1.833 178.065)"
                fill="#ededed"
              />
              <rect
                id="Rectangle_93"
                data-name="Rectangle 93"
                width="36"
                height="53.625"
                transform="translate(1.833 178.065)"
                fill="#fff"
              />
              <rect
                id="Rectangle_94"
                data-name="Rectangle 94"
                width="1"
                height="53.625"
                transform="translate(1.833 178.065)"
                fill="#dedede"
              />
              <path
                id="Path_273"
                data-name="Path 273"
                d="M21.149,233.315H18.518a.809.809,0,0,0-.809.809v2.631a.81.81,0,0,0,.809.81h2.631a.81.81,0,0,0,.81-.81v-2.631a.81.81,0,0,0-.81-.809"
                fill="#a6a6a7"
              />
              <path
                id="Path_274"
                data-name="Path 274"
                d="M34.959,175.382a.625.625,0,1,0,.625.625.625.625,0,0,0-.625-.625"
                fill="#dd4b4b"
              />
              <rect
                id="Rectangle_95"
                data-name="Rectangle 95"
                width="7.458"
                height="0.75"
                transform="translate(16.104 175.632)"
                fill="#a6a6a7"
              />
              <g id="Group_93" data-name="Group 93" opacity="0.4">
                <g id="Group_92" data-name="Group 92">
                  <g
                    id="Group_91"
                    data-name="Group 91"
                    clip-path="url(#clip-path-8)"
                  >
                    <path
                      id="Path_275"
                      data-name="Path 275"
                      d="M28.945,178.065,1.833,221.325V231.69H3.4l33.607-53.625Z"
                      fill="#dedede"
                    />
                    <path
                      id="Path_276"
                      data-name="Path 276"
                      d="M17.957,231.69l19.876-31.715v-8.787L12.45,231.69Z"
                      fill="#dedede"
                    />
                  </g>
                </g>
              </g>
              <path
                id="Path_277"
                data-name="Path 277"
                d="M23.506,216.277h-.957V213.8a2.715,2.715,0,0,0-5.431,0v2.48h-.956v5.6h7.344Zm-5.277-2.48a1.6,1.6,0,0,1,3.209,0v2.48H18.229Z"
                fill="#dedede"
              />
              <rect
                id="Rectangle_97"
                data-name="Rectangle 97"
                width="37.282"
                height="24.359"
                transform="translate(272.476 107.784)"
                fill="#979797"
              />
              <path
                id="Path_278"
                data-name="Path 278"
                d="M272.476,107.785l18.641,15.144,18.641-15.144Z"
                fill="#8f8f8f"
              />
              <path
                id="Path_279"
                data-name="Path 279"
                d="M272.476,107.785l18.641,11.24,18.641-11.24Z"
                fill="#b1b2b4"
              />
              <rect
                id="Rectangle_98"
                data-name="Rectangle 98"
                width="18.781"
                height="17.743"
                transform="translate(301.493 228.007)"
                fill="#8f8f8f"
              />
              <rect
                id="Rectangle_99"
                data-name="Rectangle 99"
                width="34.262"
                height="1.617"
                transform="translate(293.753 245.07)"
                fill="#8f8f8f"
              />
              <path
                id="Path_280"
                data-name="Path 280"
                d="M357.726,165.082H264.042a1.548,1.548,0,0,0-1.548,1.548v61.546a1.548,1.548,0,0,0,1.548,1.548h93.684a1.548,1.548,0,0,0,1.548-1.548V166.63a1.548,1.548,0,0,0-1.548-1.548"
                fill="#b1b2b4"
              />
              <path
                id="Path_281"
                data-name="Path 281"
                d="M348.179,224.426a1.189,1.189,0,1,0,1.188,1.189,1.189,1.189,0,0,0-1.188-1.189"
                fill="#dd4b4b"
              />
              <rect
                id="Rectangle_100"
                data-name="Rectangle 100"
                width="90.133"
                height="51.736"
                transform="translate(265.817 169.366)"
                fill="#fff"
              />
              <rect
                id="Rectangle_101"
                data-name="Rectangle 101"
                width="90.133"
                height="4.85"
                transform="translate(265.817 174.284)"
                fill="#d1d1d1"
              />
              <rect
                id="Rectangle_102"
                data-name="Rectangle 102"
                width="90.133"
                height="1.299"
                transform="translate(265.817 211.719)"
                fill="#d1d1d1"
              />
              <rect
                id="Rectangle_103"
                data-name="Rectangle 103"
                width="90.133"
                height="1.299"
                transform="translate(265.817 216.064)"
                fill="#d1d1d1"
              />
              <rect
                id="Rectangle_104"
                data-name="Rectangle 104"
                width="30.314"
                height="22.836"
                transform="translate(271.179 184.726)"
                fill="#d1d1d1"
              />
              <rect
                id="Rectangle_105"
                data-name="Rectangle 105"
                width="42.035"
                height="0.876"
                transform="translate(308.391 184.725)"
                fill="#d1d1d1"
              />
              <rect
                id="Rectangle_106"
                data-name="Rectangle 106"
                width="42.035"
                height="0.876"
                transform="translate(308.391 187.756)"
                fill="#d1d1d1"
              />
              <rect
                id="Rectangle_107"
                data-name="Rectangle 107"
                width="28.158"
                height="0.876"
                transform="translate(308.391 190.788)"
                fill="#d1d1d1"
              />
              <rect
                id="Rectangle_108"
                data-name="Rectangle 108"
                width="28.158"
                height="0.876"
                transform="translate(308.391 193.819)"
                fill="#d1d1d1"
              />
              <rect
                id="Rectangle_109"
                data-name="Rectangle 109"
                width="28.158"
                height="0.876"
                transform="translate(308.391 196.851)"
                fill="#d1d1d1"
              />
              <rect
                id="Rectangle_110"
                data-name="Rectangle 110"
                width="8.757"
                height="0.876"
                transform="translate(341.669 190.788)"
                fill="#d1d1d1"
              />
              <rect
                id="Rectangle_111"
                data-name="Rectangle 111"
                width="8.757"
                height="0.876"
                transform="translate(341.669 193.819)"
                fill="#d1d1d1"
              />
              <rect
                id="Rectangle_112"
                data-name="Rectangle 112"
                width="8.757"
                height="0.876"
                transform="translate(341.669 196.851)"
                fill="#d1d1d1"
              />
              <rect
                id="Rectangle_113"
                data-name="Rectangle 113"
                width="42.035"
                height="0.876"
                transform="translate(308.391 199.882)"
                fill="#d1d1d1"
              />
              <rect
                id="Rectangle_114"
                data-name="Rectangle 114"
                width="33.278"
                height="0.876"
                transform="translate(308.391 202.913)"
                fill="#d1d1d1"
              />
              <rect
                id="Rectangle_115"
                data-name="Rectangle 115"
                width="33.278"
                height="0.876"
                transform="translate(308.391 206.686)"
                fill="#d1d1d1"
              />
              <g id="Group_96" data-name="Group 96" opacity="0.5">
                <g id="Group_95" data-name="Group 95">
                  <g
                    id="Group_94"
                    data-name="Group 94"
                    clip-path="url(#clip-path-9)"
                  >
                    <path
                      id="Path_282"
                      data-name="Path 282"
                      d="M326.428,221.1l29.522-39.81V169.366h-1.975L315.609,221.1Z"
                      fill="#dedede"
                    />
                  </g>
                </g>
              </g>
              <g id="Group_99" data-name="Group 99" opacity="0.5">
                <g id="Group_98" data-name="Group 98">
                  <g
                    id="Group_97"
                    data-name="Group 97"
                    clip-path="url(#clip-path-10)"
                  >
                    <path
                      id="Path_283"
                      data-name="Path 283"
                      d="M285.544,221.1l38.366-51.736H318.5L280.135,221.1Z"
                      fill="#dedede"
                    />
                  </g>
                </g>
              </g>
              <g id="Group_102" data-name="Group 102" opacity="0.5">
                <g id="Group_101" data-name="Group 101">
                  <g
                    id="Group_100"
                    data-name="Group 100"
                    clip-path="url(#clip-path-11)"
                  >
                    <path
                      id="Path_284"
                      data-name="Path 284"
                      d="M308.185,169.366H297.366L265.817,211.91V221.1h4Z"
                      fill="#dedede"
                    />
                  </g>
                </g>
              </g>
              <rect
                id="Rectangle_119"
                data-name="Rectangle 119"
                width="31.961"
                height="20.002"
                transform="translate(63.206 126.093)"
                fill="#b1b2b4"
              />
              <path
                id="Path_285"
                data-name="Path 285"
                d="M65.619,143.745v10.831l9.43-11.98Z"
                fill="#b1b2b4"
              />
              <rect
                id="Rectangle_120"
                data-name="Rectangle 120"
                width="17.664"
                height="1.238"
                transform="translate(73.417 129.147)"
                fill="#fff"
              />
              <rect
                id="Rectangle_121"
                data-name="Rectangle 121"
                width="8.522"
                height="1.238"
                transform="translate(82.558 133.112)"
                fill="#fff"
              />
              <rect
                id="Rectangle_122"
                data-name="Rectangle 122"
                width="8.522"
                height="1.238"
                transform="translate(82.558 137.077)"
                fill="#fff"
              />
              <rect
                id="Rectangle_123"
                data-name="Rectangle 123"
                width="17.664"
                height="1.238"
                transform="translate(73.417 141.041)"
                fill="#fff"
              />
              <rect
                id="Rectangle_124"
                data-name="Rectangle 124"
                width="37.282"
                height="23.332"
                transform="translate(42.078 119.151)"
                fill="#979797"
              />
              <path
                id="Path_286"
                data-name="Path 286"
                d="M44.893,139.741v12.635l11-13.975Z"
                fill="#979797"
              />
              <rect
                id="Rectangle_125"
                data-name="Rectangle 125"
                width="27.75"
                height="1.444"
                transform="translate(46.844 122.713)"
                fill="#fff"
              />
              <rect
                id="Rectangle_126"
                data-name="Rectangle 126"
                width="13.389"
                height="1.444"
                transform="translate(61.206 127.338)"
                fill="#fff"
              />
              <rect
                id="Rectangle_127"
                data-name="Rectangle 127"
                width="13.389"
                height="1.444"
                transform="translate(61.206 131.963)"
                fill="#fff"
              />
              <rect
                id="Rectangle_128"
                data-name="Rectangle 128"
                width="10.514"
                height="1.444"
                transform="translate(46.844 127.338)"
                fill="#fff"
              />
              <rect
                id="Rectangle_129"
                data-name="Rectangle 129"
                width="10.514"
                height="1.444"
                transform="translate(46.844 131.963)"
                fill="#fff"
              />
              <rect
                id="Rectangle_130"
                data-name="Rectangle 130"
                width="27.75"
                height="1.444"
                transform="translate(46.844 136.588)"
                fill="#fff"
              />
              <path
                id="Path_287"
                data-name="Path 287"
                d="M81.686,183.247a2.45,2.45,0,1,1,2.449,2.449A2.45,2.45,0,0,1,81.686,183.247Z"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_288"
                data-name="Path 288"
                d="M74.286,149.226v13.608l9.849,5.035V180.8"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <path
                id="Path_289"
                data-name="Path 289"
                d="M78.644,176.248v-15.82l3.582-2.308V146.079"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_37"
                data-name="Line 37"
                y2="12.245"
                transform="translate(78.644 182.007)"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
              <line
                id="Line_38"
                data-name="Line 38"
                y2="4.296"
                transform="translate(78.644 200.247)"
                fill="none"
                stroke="#b1b2b4"
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
              />
            </g>
          </g>
        </g>
      </svg>
    </div>
  );
}
